// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"54bad842","455":"5cfcb383","977":"c7bdf914"}[chunkId] + ".chunk.js";
};